import { createFileRoute } from "@tanstack/react-router";
import ProgramaAgencias from "@/pages/ProgramaAgencias";
import { buildBreadcrumb, ldJson } from "@/lib/site-schema";

const breadcrumbSchema = buildBreadcrumb([{ name: "Programa para agencias", path: "/programa-agencias" }]);

export const Route = createFileRoute("/programa-agencias")({
  head: () => ({
    meta: [
      { title: "Programa para Agencias | SEOEVOLUTION - Partner SEO White Label" },
      {
        name: "description",
        content:
          "Programa de partnership para agencias digitales. Ofrece servicios SEO profesionales con comisiones del 10% al 30%. White label, soporte dedicado y garantía de resultados.",
      },
      { name: "robots", content: "index, follow" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://agenciaseoevolution.com/programa-agencias" },
      { property: "og:title", content: "Programa para Agencias | SEOEVOLUTION - Partner SEO White Label" },
      {
        property: "og:description",
        content:
          "Programa de partnership para agencias digitales. Ofrece servicios SEO profesionales con comisiones del 10% al 30%. White label, soporte dedicado y garantía de resultados.",
      },
      { name: "twitter:title", content: "Programa para Agencias | SEOEVOLUTION - Partner SEO White Label" },
      {
        name: "twitter:description",
        content:
          "Programa de partnership para agencias digitales. Ofrece servicios SEO profesionales con comisiones del 10% al 30%.",
      },
    ],
    links: [{ rel: "canonical", href: "https://agenciaseoevolution.com/programa-agencias" }],
    scripts: [ldJson(breadcrumbSchema)],
  }),
  component: ProgramaAgencias,
});
